import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=228394e1&scoped=true&"
import script from "./Sorter.vue?vue&type=script&lang=ts&"
export * from "./Sorter.vue?vue&type=script&lang=ts&"
import style0 from "./Sorter.vue?vue&type=style&index=0&id=228394e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228394e1",
  null
  
)

export default component.exports